import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-select',
  imports: [
    CommonModule,
    FormsModule
  ],
  templateUrl: './select.component.html',
  styleUrl: './select.component.css'
})
export class SelectComponent {
  isOpenSelect = false;


  @Input() valueIn : { name: string , value : any } = { name : '' , value : ''}; // ตัวแปรรับค่าเข้า
  @Input() option : { name: string , value : any }[] = []; // ตัวแปรรับค่าเข้า
  @Input() placeholder : string = 'กรุณาเลือกข้อมูล';
  @Input() disabled : boolean = false; // ค่าสถานะ

  /* Output */
  @Output() valueOut = new EventEmitter<{ name: string, value: any }>(); // ตัวแปรส่งค่าออก ตาม ค่า option ที่ส่งเข้ามา



  @ViewChild('trigger', { read: ElementRef }) trigger!: ElementRef;
  dropdownTop = 0;
  dropdownLeft = 0;
  dropdownWidth = 0;

  toggleDropdown() {
    this.isOpenSelect = !this.isOpenSelect;
    if (this.isOpenSelect && this.trigger) {
      const rect = this.trigger.nativeElement.getBoundingClientRect();
      this.dropdownTop = rect.bottom + window.scrollY;
      this.dropdownLeft = rect.left;
      this.dropdownWidth = rect.width;
    }
  }
  constructor(
    
  ) {
  }


  /* ----------------------------------------------------- Function ------------------------------------------------ */
  /* --- style --- */

  /* --- function --- */
  onClickSelect(item: any) {
    this.valueOut.emit(item);
    this.isOpenSelect = false;
    console.log('ได้ค่าจากลูก:', item);
  }


  /* ----------------------------------------------------- ตัวอย่าง หน้าหลัก รับ ค่า  ------------------------------------------------ */
  receiveData(value: any) {
    this.valueIn = value;
    console.log('ได้ค่าจากลูก:', value);
  }
}
